(() => {
  'use strict';
  const dialog = document.getElementById('SoftfireFavorites');
  if (!dialog || window.softfireFavoritesInitialized) return;
  window.softfireFavoritesInitialized = true;
  document.documentElement.classList.add('sf-js');
  const key = 'softfire:favorites:v1';
  const valid = (value) => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,199}$/.test(value);
  const normalize = (items) => Array.isArray(items) ? [...new Set(items.filter(valid))].slice(0, 50) : [];
  let saved = [];
  let storageAvailable = true;
  let opener;
  let renderVersion = 0;
  let controller;
  try {
    const raw = localStorage.getItem(key);
    try { saved = normalize(JSON.parse(raw || '[]')); } catch { saved = []; }
  } catch { storageAvailable = false; }
  const items = dialog.querySelector('[data-sf-items]');
  const status = document.getElementById('SoftfireSaveStatus');
  const storageNote = dialog.querySelector('[data-sf-storage]');
  const update = () => {
    document.querySelectorAll('[data-sf-save]').forEach((button) => {
      const active = saved.includes(button.dataset.sfSave);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? button.dataset.removeLabel : button.dataset.saveLabel);
    });
    document.querySelectorAll('[data-sf-count]').forEach((badge) => {
      badge.textContent = String(saved.length);
      badge.hidden = saved.length === 0;
    });
    storageNote.hidden = storageAvailable;
    storageNote.textContent = dialog.dataset.storage;
  };
  const persist = () => {
    try { localStorage.setItem(key, JSON.stringify(saved)); }
    catch { storageAvailable = false; }
    update();
  };
  const message = (copy, className = 'sf-empty') => {
    const paragraph = document.createElement('p');
    paragraph.className = className;
    paragraph.textContent = copy;
    return paragraph;
  };
  const root = dialog.dataset.root.endsWith('/') ? dialog.dataset.root : `${dialog.dataset.root}/`;
  const render = async () => {
    const version = ++renderVersion;
    controller?.abort();
    controller = new AbortController();
    const signal = controller.signal;
    items.replaceChildren();
    items.setAttribute('aria-busy', 'true');
    if (!saved.length) {
      items.append(message(dialog.dataset.empty));
      items.setAttribute('aria-busy', 'false');
      return;
    }
    // Limit concurrent requests; retained order is the user's saved order.
    const handles = [...saved];
    const rows = handles.map((handle) => {
      const holder = document.createElement('div');
      holder.append(message(dialog.dataset.loading));
      items.append(holder);
      return { handle, holder };
    });
    let next = 0;
    const worker = async () => {
      while (next < rows.length) {
        const { handle, holder } = rows[next++];
        try {
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=softfire-favorite-item`, { signal, headers: { Accept: 'text/html' } });
          if (signal.aborted || version !== renderVersion) return;
          const fragment = response.ok ? new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-sf-product]') : null;
          if (signal.aborted || version !== renderVersion) return;
          let article;
          if (fragment?.dataset.sfProduct === handle) {
            article = document.importNode(fragment, true);
            // Only section-rendered markup; prices and URLs come from Shopify.
            article.querySelectorAll('script').forEach((script) => { script.textContent = ''; script.type = 'application/json'; });
          } else {
            article = document.createElement('article');
            article.className = 'sf-saved-item';
            article.append(message(response.status === 404 ? dialog.dataset.missing : dialog.dataset.error, 'sf-saved-error'));
          }
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'sf-saved-remove';
          remove.dataset.sfRemove = handle;
          remove.textContent = dialog.dataset.remove;
          article.append(remove);
          holder.replaceChildren(article);
        } catch (error) {
          if (error.name === 'AbortError' || version !== renderVersion) return;
          holder.replaceChildren(message(dialog.dataset.error));
          const remove = document.createElement('button');
          remove.type = 'button'; remove.className = 'sf-saved-remove';
          remove.dataset.sfRemove = handle; remove.textContent = dialog.dataset.remove;
          holder.append(remove);
        }
      }
    };
    await Promise.all(Array.from({ length: Math.min(3, rows.length) }, worker));
    if (version === renderVersion) items.setAttribute('aria-busy', 'false');
  };
  const close = () => { controller?.abort(); dialog.close(); opener?.focus(); };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sf-save], [data-sf-open], [data-sf-close], [data-sf-remove]');
    if (!button) return;
    if (button.hasAttribute('data-sf-save')) {
      const handle = button.dataset.sfSave;
      if (!valid(handle)) return;
      const active = saved.includes(handle);
      if (!active && saved.length >= 50) saved = saved.slice(1);
      saved = active ? saved.filter((item) => item !== handle) : [...saved, handle];
      persist();
      status.textContent = active ? status.dataset.unsaved : status.dataset.saved;
    } else if (button.hasAttribute('data-sf-open')) {
      opener = button;
      dialog.showModal();
      render();
    } else if (button.hasAttribute('data-sf-close')) {
      close();
    } else {
      saved = saved.filter((item) => item !== button.dataset.sfRemove);
      persist();
      render().then(() => { if (dialog.open) dialog.querySelector('[data-sf-close]').focus(); });
    }
  });
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  dialog.addEventListener('click', (event) => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
  });
  window.addEventListener('storage', (event) => {
    if (event.key !== key && event.key !== null) return;
    try { saved = normalize(JSON.parse(event.newValue || '[]')); } catch { saved = []; }
    update();
    if (dialog.open) render();
  });
  document.addEventListener('shopify:section:load', update);
  // Dawn also injects cards in search, filtering, and quick-add fragments.
  let pending = false;
  new MutationObserver((mutations) => {
    if (pending || !mutations.some((mutation) => mutation.addedNodes.length)) return;
    pending = true;
    queueMicrotask(() => { pending = false; update(); });
  }).observe(document.getElementById('MainContent'), { childList: true, subtree: true });
  update();
})();
